import { Injectable } from "@angular/core";
import { Observable, Observer } from "rxjs";
import { FileProgress } from "./file-progress";

@Injectable({
  providedIn: "root",
})
export class SelectFileService {
  constructor() {}

  readFile(file: File, encoding?: string): Observable<FileProgress> {
    return new Observable((observer: Observer<FileProgress>) => {
      var fileReader = new FileReader();

      fileReader.onprogress = (event: ProgressEvent<FileReader>) => {
        observer.next({
          status: "Loading",
          content: null,
          progress: event.loaded / file.size,
        });
      };

      fileReader.onloadend = (event: ProgressEvent<FileReader>) => {
        observer.next({
          status: "Done",
          content: fileReader.result,
          progress: 100,
        });
        observer.complete();
      };

      fileReader.onerror = (event: ProgressEvent<FileReader>) => {
        observer.error(fileReader.error);
      };

      try {
        fileReader.readAsText(file, encoding);
      } catch (err) {
        observer.error(err);
      }
    });
  }
}
